export enum SocialNetworkVariants {
  HERO = 'hero',
  FOOTER = 'footer'
}

export type SocialNetworkType = {
  [key in SocialNetworkVariants]: string;
};
